import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import './index.css'
import { App } from './App.tsx'

// After a redeploy, an open tab still holds the previous index.html and its
// lazy-route chunk hashes, which no longer exist — reload once to pick up the
// fresh build instead of showing a dead screen (Vite emits vite:preloadError
// when a dynamic import fails).
window.addEventListener('vite:preloadError', (event) => {
  const last = Number(sessionStorage.getItem('gd-chunk-reload') || 0)
  if (Date.now() - last > 60_000) {
    event.preventDefault()
    sessionStorage.setItem('gd-chunk-reload', String(Date.now()))
    window.location.reload()
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: 'var(--background)',
          color: 'var(--foreground)',
          border: '1px solid var(--border)',
        },
      }}
    />
  </StrictMode>,
)
